import angular from 'angular';
import _ from 'lodash-es';
import $ from 'jquery';
import Utils from '~/scripts/services/utils';
import APIV5 from '~/models/api';
import Node from './node';
import Method from '~/scripts/services/model/method';
import Repre from '~/scripts/services/model/repre';
import Card from './card';

/**
 * @class
 */
// @ts-ignore
class Form extends Node {
	#$filter;

	#$timeout;

	#$translate;

	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {any} form
	 * @param {Record<string, any> | undefined} data
	 */
	constructor($injector, form = undefined, data = undefined) {
		super($injector, form?.kid);

		/** @type {import('angular').IFilterService} AngularJS $filter Service */
		this.#$filter = $injector?.get('$filter');

		/** @type {import('angular').IRootScopeService} AngularJS $rootScope Service */
		this.$rootScope = $injector?.get('$rootScope');

		/** @type {import('angular').ITimeoutService} AngularJS $timeout Service */
		this.#$timeout = $injector?.get('$timeout');

		/** @type {import('angular').translate.ITranslateService} AngularJS $translate Service */
		this.#$translate = $injector?.get('$translate');

		if (form) {
			Object.assign(this, {
				attribut: form.attribut ?? [], // TODO: à confirmer !
				create:   form.create,
				isa:      form.isa,
				isfile:   form.isfile === 1,
				// kndef:    new NodeDefinition('kndef', form.kndef),       // TODO: à confirmer !
				// kndefext: new NodeDefinition('kndefext', form.kndefext), // TODO: à confirmer !
				kright:   form.kright,
				locked:   'locked' in form ? (form.locked === true || form.locked === 1) : false,
				method:   form.method && (Array.isArray(form.method) ? [...form.method] : Object.values(form.method)).map(
					m => new Method(m),
				),
				name:     form.name,
			});
		}

		/** @type {any} Form "save button" definition */
		this.btn_record = form?.btn_record;

		/** @type {any} Keys cache for JS conditionals scripts */
		this.cacheKeys = {};

		/** @type {any[]} Components structure */
		this.components = form?.components ?? [];

		/** @type {boolean} */
		this.creating = false;

		/** @type {boolean} */
		this.default = false;

		/** @type {string} Form display */
		this.display = form?.display ?? 'form';

		/** @type {any[]} Form events */
		this.events = [];

		/** @type {any} Flat components types */
		this.flatTypes = {};

		/**
		 * @type {import(
		 *   '~/components/kform/component/kform-component.controller'
		 * ).KformComponentControllerScope | undefined} Form.io instance
		 */
		this.formio = undefined;

		/** @type {import('angular').IFormController | undefined} */
		this.formAttribut = undefined;

		/** @type {?import('@knitiv/api-client-javascript').KNode} Form KID (from form builder) */
		this.formKid = null;

		/** @type {import('angular').IFormController | undefined} */
		this.formRepre = undefined;

		/** @type {import('angular').IFormController | undefined} */
		this.formRights = undefined;

		/** @type {import('angular').IFormController | undefined} Form validation for workflow tab */
		this.formWF = undefined;

		/** @type {boolean} Generic form */
		this.generic = false;

		/** @type {string} Internal identifier */
		this.id = form?.id ?? '';

		/** @type {any} Labelfs flat map */
		this.labels = {};

		/** @type {boolean} Is last form? */
		this.lastForm = form?.lastForm ?? false;

		/** @type {{key: any, path: any, type: any}[]} List of existing nodes to link (from ktable) */
		this.linkTo = [];

		/** @type {any} Flat components map */
		this.map = {};

		/** @type {boolean} Is form modified? */
		this.modified = false;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.new_isa = null;

		/** @type {import('@knitiv/api-client-javascript').KFormParams} */
		this.params = {
			defaultTab:            null,
			displayTabAttribut:    null,
			displayTabFile:        null,
			displayTabForm:        null,
			displayTabFormToolbar: null,
			displayTabHisto:       null,
			displayTabAerow:       null,
			displayTabRepre:       null,
			displayTabRights:      null,
			displayTabWF:          null,
			editable:              null,
			editableTabAttribut:   null,
			editableTabFile:       null,
			editableTabForm:       null,
			editableTabRepre:      null,
			editableTabRights:     null,
			editableTabWF:         null,
			file:                  {
				upload: {
					blacklist: null,
					camera:    null,
					html:      null,
					local:     null,
					// @ts-ignore
					maxSize:   null,
					// @ts-ignore
					minSize:   null,
					tree:      null,
					whitelist: null,
				},
			},
			forceUploadFile:       null,
			knote:                 null,
			...form?.params,
		};

		/** @type {any} Prefix */
		this.prefix = undefined;

		if (data !== undefined && 'KREPRE' in data) {
			this.repre = data.KREPRE.map(
				(/** @type {any} */ repre) => new Repre(repre),
			);
		}

		/** @type {string} Form script */
		this.script = form?.script ?? '';

		/** @type {'attribut' | 'file' | 'form' | 'graph' | 'opentext' | 'repre' | 'wf'} Default form tab */
		this.tab = 'form';

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.term = null;

		/** @type {boolean} Is form inserting or updating? (KFORMSet operation) */
		this.updating = false;

		this.viewer_mimetype = form?.viewer_mimetype;
		if (form) {
			this.updateMap(data);
		}
	}

	/**
	 * @param {string | string[]} keys
	 * @param {any} trigger
	 * @param {(arg0: any) => any} callback
	 */
	addEvent(keys, trigger, callback) {
		// eslint-disable-next-line no-param-reassign
		keys = Array.isArray(keys) ? keys : [keys];
		const { id } = this;

		for (const key of keys) {
			const nbAttempts = 20;
			const map = this.map[key];
			let selector = `#${id} `;

			let type = map?.type;

			if (key === 'KREPRE') {
				type = 'repre';
			}

			if (type) {
				switch (type) {
				case 'datagrid': {
					selector += map.parent
						? `#form-group-${map.parent} *[id^="form-group-${key}"]`
						: `#form-group-${key}`;
					break;
				}

				case 'kpath': {
					selector += map.parent
						? `#form-group-${map.parent} *[id^="${key}"]`
						: `#${key}`;
					break;
				}

				case 'ktable': {
					selector += `#form-group-${key} ktable`;
					break;
				}

				case 'radio': {
					// eslint-disable-next-line no-case-declarations
					const parentSelector = map.parent
						? `${selector}#form-group-${map.parent} *[id^="${key}"]`
						: `${selector}#form-group-${key}`;

					selector += `${parentSelector} input[type=radio], ${selector}#form-group-${key} .radio-delete`;

					if (trigger === 'change') {
						// eslint-disable-next-line no-param-reassign
						trigger = 'click';
					}
					break;
				}

				case 'mf': {
					selector += map.parent
						? `#form-group-${map.parent} div[id^="${key}"]`
						: `#${key}`;
					break;
				}

				case 'smartfield': {
					selector += map.parent
						? `#form-group-${map.parent} *[id^="${key}"] input.form-control`
						: `#${key} input.form-control`;
					break;
				}

				default: {
					selector += map.parent
						? `#form-group-${map.parent} *[id^="${key}"]`
						: `#${key}`;
				}
				}

				const backoff = (
					/** @type {number} */ retries,
					/** @type {Function} */ ifn,
				) => ifn().catch((/** @type {any} */ error) => {
					if (retries > 1) {
						return this.#$timeout(() => backoff(retries - 1, ifn), 500);
					}

					throw error;
				});

				backoff(nbAttempts, () => {
					const element = $(selector);
					if (element.length === 0) {
						return Promise.reject(new Error('not found'));
					}
					return Promise.resolve(element);
				})
					// eslint-disable-next-line no-loop-func
					.then((/** @type {any} */ element) => {
						const { events } = this;
						events.push({ trigger, element });
						// eslint-disable-next-line promise/no-callback-in-promise
						return element.bind(trigger, (
							/** @type {Event} */ event,
							// eslint-disable-next-line promise/no-callback-in-promise
						) => this.#$timeout(() => callback(event)));
					})
					.catch(() => {
						console.warn(`DOM Element not found for ${key}`, `\nselector is ${selector}`);
					});
			}
		}
	}

	/**
	 * @param {string} key
	 * @returns {boolean}
	 */
	checkSubmit(key) {
		if (!(key in this.map)) {
			return false;
		}

		let returnCheckSubmit = this.map[key].submit === true;

		if (returnCheckSubmit && this.map[key].fpath?.length > 0) {
			for (const fpathKey of this.map[key].fpath) {
				const component = this.getComponent(fpathKey);
				if (component?.nochildrensubmit) {
					returnCheckSubmit = false;
				}
			}
		}

		return returnCheckSubmit;
	}

	export() {
		const form = {
			components: this.components.map(component => this.exportComponent(component)),
			create:     this.create,
			display:    this.display,
			name:       this.getName(),
			params:     this.params,
			script:     this.script,
		};
		return angular.toJson(form);
	}

	/**
	 * @param {any} c
	 * @returns {import('@knitiv/api-client-javascript').FormComponent}
	 */
	exportComponent(c) {
		const component = { ...c };
		if (component.validate?.card instanceof Card) {
			component.validate.card = component.validate.card.toString();
		}
		else if (typeof component.validate?.card === 'object') {
			component.validate.card = `${component.validate.card.from}-${component.validate.card.to}`
		}
		if (component.type === 'table' && 'rows' in component) {
			for (const row of component.rows) {
				for (const col of row) {
					col.components = col.components.map((/** @type {any} */ c2) => this.exportComponent(c2));
				}
			}
		}
		else if (component.type === 'columns' && 'columns' in component) {
			for (const column of component.columns) {
				column.components = column.components.map((/** @type {any} */ c2) => this.exportComponent(c2));
			}
		}
		else if (component.type === 'tabs' && 'tabs' in component) {
			for (const tab of component.tabs) {
				tab.components = tab.components.map((/** @type {any} */ c2) => this.exportComponent(c2));
			}
		}
		else if ('components' in component) {
			component.components = component.components.map((/** @type {any} */ c2) => this.exportComponent(c2));
		}
		return component;
	}

	/**
	 * @param {any} newForm
	 */
	import(newForm) {
		_.extend(this, newForm);
	}

	/**
	 * @param {any} error
	 * @returns {boolean}
	 */
	filterError(error) {
		return !!error?.$name;
	}

	/**
	 * @param {any[]} components
	 * @param {string} key
	 * @param {any[]} path
	 * @param {Function} function_
	 * @returns {any}
	 */
	findComponent(components, key, path, function_) {
		if (!components || !function_ || typeof function_ !== 'function') {
			return;
		}

		if (!key) {
			// eslint-disable-next-line consistent-return
			return function_(components);
		}

		// eslint-disable-next-line no-param-reassign
		path = path || [];

		for (const [index, component] of components.entries()) {
			const newPath = [...path];
			newPath.push(index);
			if (component) {
				if (component.key === key) {
					function_(component, newPath);
				}
				else if ('columns' in component && Array.isArray(component.columns)) {
					newPath.push('columns');
					for (const [indexColumn, column] of component.columns.entries()) {
						const colPath = [...newPath];
						colPath.push(indexColumn, 'components');
						this.findComponent(column.components, key, colPath, function_);
					}
				}
				else if ('rows' in component && Array.isArray(component.rows)) {
					newPath.push('rows');
					for (const [indexRow, row] of component.rows.entries()) {
						const rowPath = [...newPath];
						rowPath.push(indexRow);
						for (const [indexColumn, column] of row.entries()) {
							const colPath = [...rowPath];
							colPath.push(indexColumn, 'components');
							this.findComponent(column.components, key, colPath, function_);
						}
					}
				}
				else if ('tabs' in component && Array.isArray(component.tabs)) {
					newPath.push('tabs');
					for (const [indexTab, tab] of component.tabs.entries()) {
						const colPath = [...newPath];
						colPath.push(indexTab, 'components');
						this.findComponent(tab.components, key, colPath, function_);
					}
				}
				else if ('components' in component && Array.isArray(component.components)) {
					newPath.push('components');
					this.findComponent(component.components, key, newPath, function_);
				}
			}
		}
	}

	/**
	 * @param {any} components
	 * @param {string} type
	 * @param {Function} function_
	 * @returns {any}
	 */
	findComponentByType(components, type, function_) {
		if (!components || !function_ || typeof function_ !== 'function') {
			return;
		}

		if (!type) {
			// eslint-disable-next-line consistent-return
			return function_(components);
		}

		for (const component of Object.values(components)) {
			if (component) {
				if ('columns' in component && Array.isArray(component.columns)) {
					for (const column of component.columns) {
						this.findComponentByType(column.components, type, function_);
					}
				}

				if ('rows' in component && Array.isArray(component.rows)) {
					for (const row of component.rows) {
						for (const column of row) {
							this.findComponentByType(column.components, type, function_);
						}
					}
				}

				if ('tabs' in component && Array.isArray(component.tabs)) {
					for (const tab of component.tabs) {
						this.findComponentByType(tab.components, type, function_);
					}
				}

				if ('components' in component && Array.isArray(component.components)) {
					this.findComponentByType(component.components, type, function_);
				}

				if (component.type === type) {
					function_(component);
				}
			}
		}
	}

	/**
	 * @param {boolean} flagCreate
	 */
	fixKtableOptionParentCreate(flagCreate) {
		this.findComponentByType(this.components, 'ktable', (/** @type {any} */ c) => {
			c.options.parent.create = flagCreate;
		});
	}

	/**
	 * Get component by key
	 *
	 * @param {string} key Component key
	 * @returns {any} Form component
	 */
	getComponent(key) {
		/** @type {any[]} */
		const path = [];

		/**
		 * @type {{component: any}}
		 */
		const returnValue = {
			component: undefined,
		};

		this.findComponent(this.components, key, path, (/** @type {any} */ c) => {
			returnValue.component = c;
		});

		if (returnValue.component?.type === 'ktable') {
			const ctrlComponentKtable = angular.element(`.kform-component-${returnValue.component.key} ktable`);
			if (ctrlComponentKtable) {
				// @ts-ignore
				const ctrlKtable = ctrlComponentKtable.children()?.scope()?.$ctrl;
				if (ctrlKtable?.table) {
					returnValue.component.table = ctrlKtable.table;
					returnValue.component.exec = () => {
						this.$rootScope.$broadcast(
							`ktable-refresh-${returnValue.component.options.parent.kid}-${returnValue.component.key}`,
							{ script: false },
						);
					};
				}
			}
		}

		return returnValue.component;
	}

	/**
	 * Get component path by key
	 *
	 * @param {string} key Component key
	 * @returns {any[]} Path
	 */
	getComponentPath(key) {
		/** @type {any[]} */
		const path = [];

		/** @type {{path: any[]}} */
		const returnValue = { path: [] };

		this.findComponent(this.components, key, path, (/** @type {any} */ c, /** @type {any[]} */ newPath) => {
			returnValue.path = newPath;
		});

		return returnValue.path;
	}

	/**
	 * @param {string} id
	 * @param {string} key
	 * @returns {string}
	 */
	getErrorDescription(id, key) {
		if (id === 'mincard') {
			const component = this.getComponent(key);
			if (component?.validate?.card) {
				return this.#$filter('sprintf')(this.#$translate.instant('error.kform.' + id), component.validate.card.from);
			}
		}
		return this.#$translate.instant('error.kform.' + id);
	}

	/**
	 * @param {any} error
	 * @returns {string} Error message
	 */
	getLabelFromError(error) {
		const r = /^(.+)-\d+-\d+$/.exec(error.$name);
		let label;
		let key = error.$name;

		if (r && r[1]) {
			[
				,
				key,
			] = r;
		}
		if (key in this.labels) {
			label = this.labels[key];
		}
		else {
			// this is probably a datagrid so we have to find parent
			const path = _.dropRight(this.getComponentPath(key), 2);
			const parent = _.get(this.components, path);
			const component = this.getComponent(key);

			label = parent ? parent.label || parent.title : key;
			if (component) {
				if (label) {
					label += ` / ${component.label}`;
				}
				else {
					({ label } = component);
				}
			}
		}

		return `${label} : `;
	}

	// eslint-disable-next-line class-methods-use-this
	/**
	 * @param {string} key
	 * @returns {string}
	 */
	getValue(key) {
		return key;
	}

	/**
	 * @param {string} key
	 */
	hideComponent(key) {
		const component = this.getComponent(key);
		component.hidden = true;
		component.nochildrensubmit = true;
	}

	/**
	 * @param {string} event
	 * @param {Function} callback
	 */
	on(event, callback) {
		this.$rootScope.$on(`Form.${event}`, event_ => callback(event_));
	}

	refresh() {
		this.$rootScope?.$broadcast('Form.refresh');
	}

	removeEvents() {
		for (const event of this.events) {
			event.element.unbind();
		}
	}

	/**
	 * @param {import(
	 *   '~/components/kform/component/kform-component.controller'
	 * ).KformComponentControllerScope} scope
	 */
	setScope(scope) {
		this.formio = scope;
	}

	/**
	 * @param {string} source
	 * @param {string} destination
	 * @param {any[]} path
	 * @param {any} data
	 */
	async setValueFromPath(source, destination, path, data) {
		const result = new Set();
		if (Array.isArray(data[source]) && data[source].length > 0) {
			for (/** @type {any} */ const value of data[source]) {
				const pathInfo = await APIV5.instance.queryPathInfo({
					list: [
						{
							node_kid: value.kid,
							path,
						},
					],
				}, { id: 'script' });
				if (pathInfo?.result?.list[0].rows) {
					const rows = pathInfo?.result?.list[0].rows;
					if (rows.length > 0) {
						rows[0][0].map((/** @type {any} */ cell) => result.add(cell));
					}
				}
			}
			data[destination] = [...result];
		}
		else {
			data[destination] = undefined;
		}
		this.updateForm(this);
	}

	/**
	 * @param {string} key
	 */
	showComponent(key) {
		const component = this.getComponent(key);
		component.hidden = false;
		component.nochildrensubmit = false;
	}

	/**
	 * @param {string} key
	 * @param {any} newComponent
	 * @returns {boolean}
	 */
	updateComponent(key, newComponent) {
		let returnValue = false;
		const component = typeof key === 'object' ? key : this.getComponent(key);

		if (component) {
			returnValue = true;
			const oldComponent = { ...component };
			_.merge(component, newComponent);
			if ('kdata' in newComponent) {
				this.updateMap();
			}
			if (!_.isEqual(oldComponent, component)) {
				this.$rootScope?.$broadcast('Form.updateComponent', component);
				this.updateForm(this);
			}
		}
		else {
			console.error('Form.updateComponent: component not found', key);
		}

		return returnValue;
	}

	/**
	 * @param {Form} form
	 */
	updateForm(form) {
		if (!this.updating) {
			this.updating = true;
			this.#$timeout(() => {
				this.$rootScope?.$broadcast('Form.update', form);
				this.updating = false;
			}, 500);
		}
	}


	/**
	 * Generates the map of the form
	 *
	 * @param {any} data Data from submission
	 */
	// eslint-disable-next-line class-methods-use-this
	updateMap(data = undefined) {
		this.map = {};
		this.labels = {};
		this.flatTypes = {};

		const genMapComponents = (
			/** @type {import('@knitiv/api-client-javascript').FormComponent[]} */ components,
			/** @type {any} */ type = undefined,
			/** @type {any} */ parent = undefined,
			/** @type {any[]} */ fpath = [],
		) => {
			for (const component of components) {
				// if (component.key in this.map) {
				// 	throw 'key already exists: ' + component.key;
				// }
				if ('components' in component) {
					if (component.type === 'datagrid') {
						this.map[component.key] = component.kdata || {};
						this.map[component.key].type = component.kdata?.type || component.type;
						this.map[component.key].components = component.components.map((
							/** @type {any} */ component2,
						) => component2.key);
						this.labels[component.key] = component.label;
					}
					// this.map[component.key].fpath = fpath;
					if (component.components) {
						genMapComponents(component.components, component.type, component.key, [
							...fpath,
							component.key,
						]);
					}
				}
				else if (component.type === 'table' && 'rows' in component) {
					for (const row of component.rows) {
						for (const col of row) {
							if (col.components) {
								genMapComponents(col.components, component.type, component.key, [
									...fpath,
									component.key,
								]);
							}
						}
					}
				}
				else if (component.type === 'columns' && 'columns' in component) {
					for (const col of component.columns) {
						if (col.components) {
							genMapComponents(col.components, component.type, component.key, [
								...fpath,
								component.key,
							]);
						}
					}
				}
				else if (component.type === 'tabs' && 'tabs' in component) {
					for (const tab of component.tabs) {
						if (tab.components) {
							genMapComponents(tab.components, component.type, component.key, [
								...fpath,
								component.key,
							]);
						}
					}
				}
				else {
					if ('kdata' in component && component.key) {
						// ----  TEST -----
						// if (['K_NODE;DOC_053', 'K_NODE;DOC_056_1', 'K_NODE;DOC_056_2', 'K_NODE;DOC_056_3']
						//     .indexOf(component.kdata.kid) >= 0) {
						// 	component.kdata.uploadFile = true;
						// 	if (component.kdata.kid !== 'K_NODE;DOC_053') {
						// 		component.validate.card = '0-N';
						// 	}
						// }
						// ----------------
						this.map[component.key] = { ...component.kdata };
						this.map[component.key].label = component.label;
						this.map[component.key].type = component.kdata.type || component.type;
						this.map[component.key].fpath = fpath;
						this.labels[component.key] = component.label;
						if ('values' in component) {
							this.map[component.key].values = component.values;
						}
						if (data && !(component.key in data) && !component.defaultValue && type !== 'datagrid') {
							data[component.key] = undefined;
						}
						if (component.type === 'datetime') {
							this.map[component.key].enableTime = !!component.enableTime;
						}
						if (component.type === 'jsoneditor') {
							this.map[component.key].preferText = component.preferText;
						}
						this.map[component.key].parent = parent;
					}
					else {
						console.warn('no kdata', component.key);
					}

					if ('type' in component) {
						this.flatTypes[component.key] = component.type;
					}

					// rétro-compatibilité
					if (component.validate && 'required' in component.validate) {
						component.validate.card = new Card(
							component.validate.required === true ? 1 : 0,
							component.multiple === true ? 'N' : 1,
						)
						delete component.validate.required;
						this.#$timeout(() => {
							this.$rootScope.$emit('FormBuilder.update');
						});
					}

					if ('multiple' in component) {
						delete component.multiple;
						this.#$timeout(() => {
							this.$rootScope.$emit('FormBuilder.update');
						});
					}

					if (typeof component.validate?.card === 'string') {
						component.validate.card = new Card(component.validate.card);
					}
				}
			}
		};

		genMapComponents(this.components);
	}


	/**
	 * @param {import('~/scripts/services/model/file-upload').default[]} files
	 * @param {any} submission
	 * @returns {Promise<boolean>}
	 */
	async upload(files, submission) {
		if (files && this.params.editableTabFile) {
			submission.files = [];
			for (const file of files) {
				/** @type {any} */
				const f = {};
				if (file.uploaded) {
					if (file.deleted) {
						f.action = 'DEL';
						f.id = file.id;
					}
					else if (file.file instanceof File) {
						await file.upload();
						f.fileid = file.uploadFileId;
						f.action = 'MOD';
						f.id = file.id;
					}
				}
				else {
					const uploaded = await file.upload();
					if (!uploaded) {
						throw new Error('File is not uploaded');
					}
					file.uploaded = uploaded;
					file.uploadInit = false;
					f.fileid = file.uploadFileId;
					f.action = 'ADD';
				}
				if ('tree_kid' in file.file) {
					submission.tree_kid = file.file.tree_kid;
					// @ts-ignore
					submission.relpath = file.file.relpath;
				}
				if (f.action) {
					submission.files.push(f);
				}
			}
		}
		return true;
	}

	/**
	 * @returns {string}
	 */
	uuid() {
		return Utils.guid();
	}
}

export default Form;
